import React from "react"
import styles from './byline.module.scss'
import Moment from 'react-moment';
import '../../node_modules/moment/locale/fr-ca';

const Byline = (props) => {
  // console.log('!!!!!!!!!!props: '+ JSON.stringify(props))
  return(
    <div>
      <div className={styles.authorName}>
      {(props.author) ? generateNameString(props.author) :  <div className={styles.authoring} dangerouslySetInnerHTML={{ __html: props.authoring }} />}
      </div>
      <div className={styles.creationDate}>
        {createDateString(props.datelineCreationDate)}
      </div>
      <div className={styles.updateDate}>
        <img alt="clockIcon" className={styles.clock} src="https://m1.quebecormedia.com/emp/jdx-prod-images/photo/c6e05e39-0773-4b5f-9e53-7ebf76598cf2_clock.svg" />
        {createDateString(props.datelineUpdateDate)}
      </div>
    </div>
  )
}

export default Byline

function generateNameString(authorsArray){
  let nameString = ''
  for (let i = 0; i<authorsArray.length; i++){
    nameString += authorsArray[i].firstName + ' ' + authorsArray[i].lastName
    if (i === authorsArray.length-2){
      nameString += ' et '
    } else if (i !== authorsArray.length-1){
      nameString += ', '
    }
  }
  return nameString
}

function createDateString(timestamp){
  let formattedTime = <Moment format="dddd D MMMM YYYY h:mm" locale="fr-ca">{timestamp}</Moment>
  return formattedTime
}